// extracted by mini-css-extract-plugin
export var aircallIframe = "_hh-3";
export var fabContainer = "_hh-5";
export var fabRinging = "_hh-6";
export var loadingOverlay = "_hh-4";
export var pulse = "_hh-7";
export var widgetContent = "_hh-2";
export var widgetPanel = "_hh-0";
export var widgetPanelExpanded = "_hh-1";